import { PUBLIC_CHAIN, PUBLIC_TENDERLY_KEY_FRONTEND } from '$env/static/public';
import { config } from './circlesV2Config';

const TENDERLY_KEY = PUBLIC_TENDERLY_KEY_FRONTEND;
export const RPC_URL_TENDERLY = `https://gnosis.gateway.tenderly.co/${TENDERLY_KEY}`;

const ANKR_PROJECT_ID = '94fe44f8aa83c72ea822888f5214fc34bbcd3e247aae275b0622742222c1de5b';
export const RPC_URL_ANKR =
  PUBLIC_CHAIN === 'GNOSIS'
    ? `https://rpc.ankr.com/gnosis/${ANKR_PROJECT_ID}`
    : `https://rpc.ankr.com/gnosis_testnet/${ANKR_PROJECT_ID}`;

export const RPC_URL_CIRCLES = config.circlesRpcUrl;

export const RPC_URL_GNOSIS = 'https://rpc.gnosischain.com/';
